import { render, staticRenderFns } from "./page-shop.vue?vue&type=template&id=6ebbc7ff&scoped=true"
import script from "./page-shop.vue?vue&type=script&lang=js"
export * from "./page-shop.vue?vue&type=script&lang=js"
import style0 from "./page-shop.vue?vue&type=style&index=0&id=6ebbc7ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebbc7ff",
  null
  
)

export default component.exports